import slugify from 'slugify';
import { pinyin } from 'pinyin-pro';

const HAS_CHINESE = /[㐀-䶿一-鿿]/;

const toAscii = text => {
  if (!text) {
    return '';
  }

  if (HAS_CHINESE.test(text)) {
    return pinyin(text, { toneType: 'none', nonZh: 'consecutive' });
  }

  return text;
};

// An apostrophe becomes a separator, never nothing: "Largo d'Amato" is an
// elision of "Largo di Amato", so dropping it welds two words into "damato".
// The lost word is not worth guessing, but the boundary is worth keeping.
export const cleanString = (text = '') =>
  slugify(toAscii(String(text || '').replace(/['’‘`]/g, '-')), {
    lower: true,
    strict: true,
    trim: true,
  });

export const getPossibleSlug = (name = '', from = '', city = '', country = '') => {
  const cleanedName = cleanString(name);
  const cleanedFrom = cleanString(from);
  const cleanedCity = cleanString(city);
  const cleanedCountry = cleanString(country);

  let slug = cleanedName;

  if (cleanedFrom) {
    slug = `${slug}-from-${cleanedFrom}`;
  }

  // A spot named after its own city reads as "catania-in-italy", never
  // "catania-in-catania-italy": the country takes over the "in".
  const cityRepeatsName = Boolean(cleanedCity) && cleanedCity === cleanedName;

  if (cleanedCity && !cityRepeatsName) {
    slug = `${slug}-in-${cleanedCity}`;
  }

  if (cleanedCountry) {
    slug = cityRepeatsName ? `${slug}-in-${cleanedCountry}` : `${slug}-${cleanedCountry}`;
  }

  return cleanString(slug);
};
